import React, { useEffect, useState } from "react";
import { Pie } from "react-chartjs-2";
import {
  Chart as ChartJS,
  // CategoryScale,
  // LinearScale,
  // ArcElement,
  // Title,
  // Tooltip,
  // Legend,
} from "chart.js";
import { Request } from "../../hooks/Request";
import { TableManagement } from "../../containers/Systems/TableManagement";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { requestAuth } from "../services/RequestService";
import { chartColors } from "../../utils/constant";
import { LoadingSkeletonChart } from "../Loaders";

ChartJS.register(
  ChartDataLabels
);

const SimplePie = ({ urlApi, title, indexRef, tableHeaders, showFilters = false }) => {
  const [procType, setProcType] = useState(0);
  const [year, setYear] = useState(0);
  const [month, setMonth] = useState(0);
  const [aduana, setAduana] = useState('');
  const [category, setCategory] = useState('');
  const [economicActivity, setEconomicActivity] = useState('');
  const [aduanaOpt, setAduanaOpt] = useState([]);
  const [categoryOpt] = useState([
    {
      label: "AA",
      value: "AA",
    },
    {
      label: "A",
      value: "A",
    },
    {
      label: "B",
      value: "B",
    },
    {
      label: "C",
      value: "C",
    },
  ]);
  const [economicActivityOpt, setEconomicActivityOpt] = useState([]);
  const { data, call } = Request({
    urlApi: `${urlApi}?procedureTypeId=${procType}&year=${year}&month=${month}&custom=${aduana}&category=${category}&economicActivity=${economicActivity}`,
  });

  const [chartData, setChartData] = useState({ labels: [], values: [], percentages: [] });

  useEffect(() => {
    if (data) {
      const labels = data.map((item) => item[indexRef[0]]);
      const values = data.map((item) => item[indexRef[1]]);
      const percentages = data.map((item) => item[indexRef[2]]);
      setChartData({ labels, values, percentages });
    }
  }, [data, indexRef]);

  useEffect(() => {
    call();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [urlApi, procType, year, month, aduana, category, economicActivity]);

  useEffect(() => {
    requestAuth('GET', '/Dropdown/listaAduanas/options', data)
      .then(function (response) {
        setAduanaOpt(response.data?.map(a => ({ value: a.name, label: a.name })))
      })
      .catch(function (error) {
        // setError(true)
      })
    requestAuth('GET', '/dropdown/tiposMeMercaderia/options', data)
      .then(function (response) {
        setEconomicActivityOpt(response.data?.map(a => ({ value: a.name, label: a.name })))
      })
      .catch(function (error) {
        // setError(true)
      })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleAduanaChange = (e) => {
    setAduana(e.target.value);
  };
  const handleProcTypeChange = (e) => {
    setProcType(e.target.value);
  };

  const handleYearChange = (e) => {
    setYear(e.target.value);
  };

  const handleMonthChange = (e) => {
    setMonth(e.target.value);
  };

  // if (!data || !loading) {
  //   return <Circle spinnerColor="text-orange-400" className={'h-96'} />
  // } else
  return (
    <div className="grid grid-cols-12 justify-center text-center mb-2">
      <h1 className="text-xl text-center uppercase mb-4 col-span-12">{title}</h1>
      {
        showFilters ?

          <div className="flex justify-center gap-4 mb-4 col-span-12">
            <select onChange={handleProcTypeChange} value={procType} className="bg-white py-1 px-2 border border-gray-300 rounded">
              <option value={0}>Todos los trámites</option>
              {[{ label: 'Importación', value: 1 }, { label: 'Exportación', value: 2 }].map(({ label, value }, idx) => (
                <option key={idx} value={value}>
                  {label}
                </option>
              ))}
            </select>
            <select onChange={handleYearChange} value={year} className="bg-white py-1 px-2 border border-gray-300 rounded">
              <option value={0}>Todos los años</option>
              {[2025, 2024, 2023, 2022, 2021, 2020, 2019].map((y) => (
                <option key={y} value={y}>
                  {y}
                </option>
              ))}
            </select>
            <select onChange={handleMonthChange} value={month} className="bg-white py-1 px-2 border border-gray-300 rounded">
              <option value={0}>Todos los meses</option>
              {[...Array(12)].map((_, i) => (
                <option key={i + 1} value={i + 1}>
                  {new Date(0, i).toLocaleString("default", { month: "long" })}
                </option>
              ))}
            </select>
            <select onChange={handleAduanaChange} value={aduana} className="bg-white py-1 px-2 border border-gray-300 rounded">
              <option value={''}>Aduana de despacho</option>
              {aduanaOpt.map(({ label, value }, idx) => (
                <option key={idx} value={value}>
                  {label}
                </option>
              ))}
            </select>
          </div>
          :
          <div className="flex justify-center gap-4 mb-4 col-span-12">
            {/* <select onChange={handleProcTypeChange} value={procType} className="bg-white py-1 px-2 border border-gray-300 rounded">
              <option value={0}>Todos los trámites</option>
              {[{ label: 'Importación', value: 1 }, { label: 'Exportación', value: 2 }].map(({ label, value }, idx) => (
                <option key={idx} value={value}>
                  {label}
                </option>
              ))}
            </select> */}
            <select onChange={handleYearChange} value={year} className="bg-white py-1 px-2 border border-gray-300 rounded">
              <option value={0}>Todos los años</option>
              {[2025, 2024, 2023, 2022, 2021, 2020, 2019].map((y) => (
                <option key={y} value={y}>
                  {y}
                </option>
              ))}
            </select>
            <select onChange={(e) => setCategory(e.target.value)} value={category} className="bg-white py-1 px-2 border border-gray-300 rounded">
              <option value={''}>Categoría</option>
              {categoryOpt.map(({ label, value }, idx) => (
                <option key={idx} value={value}>
                  {label}
                </option>
              ))}
            </select>
            <select onChange={(e) => setEconomicActivity(e.target.value)} value={economicActivity} className="bg-white py-1 px-2 border border-gray-300 rounded">
              <option value={''}>Actividad comercial</option>
              {economicActivityOpt.map(({ label, value }, idx) => (
                <option key={idx} value={value}>
                  {label}
                </option>
              ))}
            </select>
          </div>
      }
      {
        !data ?
          <div className="col-span-12">
            <LoadingSkeletonChart />
          </div>
          :
          <>
            <div
              className="m-auto col-span-12 lg:col-span-6 p-2"
              style={{
                width: "100%",
                height: "650px",
              }}
            >
              <Pie
                options={{
                  plugins: {
                    title: {
                      display: false,
                      text: title,
                    },
                    datalabels: {
                      color: "#fff",
                      formatter: (value, context) => {
                        const total = context.chart.data.datasets[0].data.reduce((acc, val) => acc + (isNaN(val) ? 0 : val), 0);
                        const percentage = total > 0 ? ((value / total) * 100).toFixed(2) : 0;
                        return `${percentage}%`;
                      },
                      font: {
                        size: 20,
                      },
                      anchor: "center",
                      align: "center",
                      backgroundColor: chartColors
                    },
                    tooltip: {
                      callbacks: {
                        label: (tooltipItem) => {
                          const index = tooltipItem.dataIndex;
                          return [
                            `${chartData.labels[index]}`,
                            `Cantidad: ${chartData.values[index]}`,
                            `Porcentaje: ${chartData.percentages[index]}`,
                          ];
                        },
                      },
                    },
                    legend: {
                      display: false,
                    },
                  },
                  responsive: true,
                  maintainAspectRatio: false,
                }}
                data={{
                  labels: chartData.labels,
                  datasets: [
                    {
                      label: title,
                      data: chartData.values,
                      backgroundColor: chartColors,
                      hoverOffset: 4,
                    },
                  ],
                }}
              />
            </div>
            {indexRef && (
              <>
                {data && (
                  <div className="py-[30px] flex justify-center gap-4 col-span-12 lg:col-span-6">
                    <div>
                      <TableManagement
                        header={tableHeaders}
                        data={data}
                        labelGrafic="trámite"
                        isLarge={true}
                      />
                    </div>
                  </div>
                )}
              </>
            )}
          </>
      }
    </div>
  );
};

export default SimplePie;